'use client';

import { PropsWithChildren, useMemo, useState } from 'react';
import { Component } from '@headless-workspace/typings';
import { EngraveFormReturnType } from '../../../../../src';
import { EngraveContext, EngraveContextValueType } from './EngraveContext';

export const EngraveProvider: Component<PropsWithChildren> = ({ children }) => {
    const [engraveFormValues, setEngraveFormValues] = useState<EngraveFormReturnType | undefined>({
        font: '',
        line1: '',
        line2: '',
        line3: '',
    });

    const engraveProviderValue: EngraveContextValueType = useMemo(
        () => ({
            engraveFormValues,
            setEngraveFormValues,
        }),
        [engraveFormValues],
    );

    return <EngraveContext.Provider value={engraveProviderValue}>{children}</EngraveContext.Provider>;
};
